
/* PARDA ONLINE - REUSABLE PRICE SLIDER */

(function () {
  "use strict";

  function parsePrice(value, fallback) {
    if (value == null || String(value).trim() === "") {
      return fallback;
    }

    const clean = String(value).replace(/,/g, "").trim();
    const num = Number(clean);
    return Number.isFinite(num) ? num : fallback;
  }

  function initSlider(slider) {
    if (slider.dataset.initialized === "true") return;

    const component = slider.closest("price-facet-component");
    if (!component) return;

    const minInput = component.querySelector('[ref="minInput"]');
    const maxInput = component.querySelector('[ref="maxInput"]');
    const minRange = slider.querySelector(".po-price-slider__min");
    const maxRange = slider.querySelector(".po-price-slider__max");
    const fill = slider.querySelector(".po-price-slider__fill");

    if (!minInput || !maxInput || !minRange || !maxRange || !fill) return;

    const limit = parsePrice(slider.dataset.max, 0);
    if (limit <= 0) return;

    slider.dataset.initialized = "true";

    function clamp(value) {
      return Math.min(limit, Math.max(0, value));
    }

    let min = clamp(parsePrice(slider.dataset.startMin, 0));
    let max = clamp(parsePrice(slider.dataset.startMax, limit));

    if (min > max) min = max;

    // The sliders always have the FULL price range available.
    minRange.min = 0;
    maxRange.min = 0;
    minRange.max = limit;
    maxRange.max = limit;

    // Avoid old selected-price limits.
    minInput.dataset.min = "0";
    minInput.dataset.max = String(limit);
    maxInput.dataset.min = "0";
    maxInput.dataset.max = String(limit);

    function draw() {
      minRange.value = min;
      maxRange.value = max;

      fill.style.left = (min / limit * 100) + "%";
      fill.style.right = (100 - max / limit * 100) + "%";

      minRange.style.zIndex = min >= max ? "4" : "2";
      maxRange.style.zIndex = "3";
    }

    function showInputs() {
      minInput.value = min === 0 ? "" : min.toFixed(2);
      maxInput.value = max === limit ? "" : max.toFixed(2);
    }

    function applyPrices() {
      const url = new URL(window.location.href);

      // Preserve other selected filters, sort order and search query.
      if (min <= 0) {
        url.searchParams.delete(minInput.name);
      } else {
        url.searchParams.set(minInput.name, min.toFixed(2));
      }

      if (max >= limit) {
        url.searchParams.delete(maxInput.name);
      } else {
        url.searchParams.set(maxInput.name, max.toFixed(2));
      }

      // Reset pagination after changing price filters.
      url.searchParams.delete("page");

      if (url.href !== window.location.href) {
        window.location.assign(url.href);
      }
    }

    minRange.addEventListener("input", function () {
      min = Math.min(Number(minRange.value), max);
      showInputs();
      draw();
    });

    maxRange.addEventListener("input", function () {
      max = Math.max(Number(maxRange.value), min);
      showInputs();
      draw();
    });

    // Stop Dwell's original change handler from
    // separately processing slider interactions.
    minRange.addEventListener("change", function (event) {
      event.stopPropagation();
      applyPrices();
    });

    maxRange.addEventListener("change", function (event) {
      event.stopPropagation();
      applyPrices();
    });

    function handleManualChange(event) {
      event.stopImmediatePropagation();
      event.stopPropagation();

      min = clamp(parsePrice(minInput.value, 0));
      max = clamp(parsePrice(maxInput.value, limit));

      if (min > max) {
        if (event.target === minInput) {
          max = min;
        } else {
          min = max;
        }
      }

      showInputs();
      draw();
      applyPrices();
    }

    minInput.addEventListener("change", handleManualChange, true);
    maxInput.addEventListener("change", handleManualChange, true);

    draw();
  }

  function initAll() {
    document.querySelectorAll(".po-price-slider").forEach(initSlider);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  function start() {
    initAll();

    const observer = new MutationObserver(function (mutations) {
      if (mutations.some(m => m.addedNodes.length > 0)) {
        initAll();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
